module.exports = __webpack_public_path__ + "static/media/munch3.20663feb.wav";